import React, {useState} from 'react';
import {Card} from 'primereact/card';
import {Button} from "primereact/button";

import {TabPanel, TabView} from 'primereact/tabview';
import {ExecutionDetailsTitle, SingleExecutionTitle} from "./PythonExecutionComponents";
import ExecutePythonScript from "./ExecutePythonScript";
import {deletePythonExecution, getPythonExecutions} from "../../api/python/python-execution-service";
import HeaderBreadCrumb from "../BreadCrumb/Breadcrumb";
import {showError, showSuccess} from "../../api/notification/ToastManager";


const PythonExecutions = ({
                              pythonExecutions,
                              setSelectedPythonExecutionIndex,
                              selectedPythonExecutionIndex,
                              setPythonExecutions
                          }) => {
    const [showNewPythonExecDialog, setShowNewPythonExecDialog] = useState(false)

    async function deleteSingleExecution(execId) {
        await deletePythonExecution(execId)
        const execs = await getPythonExecutions()
        setPythonExecutions(execs)
        setSelectedPythonExecutionIndex(-1)
    }

    async function copyToClipboard(content, section) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(content);
                showSuccess("Copied to clipboard", `Copied ${section} to clipboard`)
            } catch (err) {
                showError("Could not copy to clipboard")
            }
        } else {
            showError("Could not copy to clipboard")
        }
    }

    return <>
        <div style={{display: "flex", gap: "5px"}}>
            <div style={{flex: 1}}>
                <HeaderBreadCrumb items={["Python", "Executions"]}/>
            </div>
            <Button icon={"pi pi-plus"} style={{backgroundColor: "#487c84"}} label={"Add new execution"}
                    onClick={() => {
                        setShowNewPythonExecDialog(true)
                    }}/>
        </div>


        <div className={"mt-2"} style={{display: "flex", gap: "20px"}}>
            <div style={{flex: 1.7}}>
                <Card title={"List of executions"}
                      style={{height: "770px", maxWidth: "310px"}}>
                    {pythonExecutions?.length > 0 ? <div style={{overflowY: "auto", maxHeight: "650px"}}>
                            {pythonExecutions?.map((execution, index) => {
                                return (
                                    <div key={execution?.id}
                                         onClick={() => {
                                             setSelectedPythonExecutionIndex(index)
                                         }}
                                         style={{
                                             margin: "5px", cursor: "pointer",
                                             backgroundColor: execution.id === pythonExecutions[selectedPythonExecutionIndex]?.id ? "#eeecec" : "unset",
                                             padding: "5px",
                                             marginLeft: "10px",
                                             boxShadow: "0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12)",
                                             borderRadius: "6px",

                                         }}>
                                        <SingleExecutionTitle execution={execution}
                                                              deleteSingleExecution={deleteSingleExecution}/>
                                    </div>)
                            })}

                        </div> :
                        <span style={{color: "grey"}}>
                                Click on "Add new execution" button to add python execution</span>}
                </Card>
            </div>
            <div style={{flex: 8.3}}>
                <Card title={ExecutionDetailsTitle(pythonExecutions[selectedPythonExecutionIndex])}
                      style={{height: "770px", width: "100%"}}>
                    {pythonExecutions[selectedPythonExecutionIndex] ?
                        <TabView>
                            <TabPanel header="Script Content">
                                <div style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button
                                        onClick={async () => {
                                            await copyToClipboard(pythonExecutions[selectedPythonExecutionIndex]?.scriptContent,
                                                "script content")
                                        }}
                                        style={{color: "#487c84"}} text icon={"pi pi-copy"} size={'small'}>Copy to
                                        clipboard</Button>
                                </div>
                                <div style={{maxHeight: "510px", overflow: "auto"}}>

                                    <pre style={{whiteSpace: "pre-wrap"}}>
                                           {pythonExecutions[selectedPythonExecutionIndex]?.scriptContent}
                                       </pre>
                                </div>
                            </TabPanel>
                            <TabPanel header="Console Output">
                                <div style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button
                                        onClick={async () => {
                                            await copyToClipboard(pythonExecutions[selectedPythonExecutionIndex]?.consoleOutput,
                                                "console output")
                                        }}
                                        style={{color: "#487c84"}} text icon={"pi pi-copy"} size={'small'}>Copy to
                                        clipboard</Button>
                                </div>
                                <div style={{maxHeight: "510px", overflow: "auto"}}>
                                        <pre style={{whiteSpace: "pre-wrap"}}>
                                            {pythonExecutions[selectedPythonExecutionIndex]?.consoleOutput ?? <div>
                                                <span className={'pi pi-spinner pi-spin m-0 p-0 mr-1'}/>
                                            </div>}
                                        </pre>
                                </div>
                            </TabPanel>
                        </TabView> :
                        <div style={{width: "100%", height: "100%"}}>
                            <span style={{color: "grey"}}>
                                Select an item from the list on the left to see more details</span>
                        </div>
                    }

                </Card>
            </div>
        </div>

        <ExecutePythonScript
            setPythonExecutions={setPythonExecutions}
            setShowNewPythonExecDialog={setShowNewPythonExecDialog}
            showNewPythonExecDialog={showNewPythonExecDialog}
            setSelectedPythonExecutionIndex={setSelectedPythonExecutionIndex}
        />
    </>
}


export default PythonExecutions;